export default __webpack_public_path__ + "static/media/Mobile.56584b3d.png";